/* 核心句子学习页面 */
/*  Author: wanfengren */
/* create: 2019/07/15*/
<template>
  <div class="mainbody">
    <div style="height:0.1px"></div>

    <!-- 核心句子标题 -->

      <div id="headerdiv">
        <div class="headertitle">{{ lang.sentence_day }}</div>
      </div>

      <!-- 句子介绍-->
      <div id="textDiv" v-if="Data.sentence_en">

        <!-- 句子场景图片介绍-->
        <div class="maintext" v-if="Data.cover_picture_link">
          <img class="imgCover" id="cover_picture_link" :src="Data.cover_picture_link" title="cover">
        </div>

       <!-- 句子问答增加发音-->
        <div class="p-container phonictext">
          <p class="p-english family-english size-english orange-bold">
            <span class="p-order">Ask: </span>
            <span v-text="Data.sentence_en"></span>
            <i v-if="Data.sentence_en_mp3" class="dic-sound" @click.stop.prevent="sound(Data.sentence_en_mp3)"></i>
          </p>
          <p class="p-chinese family-chinese size-chinese blue-bold" v-if="Data.sentence_en_answer != null">
            <span class="p-order">Answer: </span>
            <span v-text="Data.sentence_en_answer"></span>
            <i v-if="Data.sentence_en_answer_mp3" class="dic-sound" @click.stop.prevent="sound(Data.sentence_en_answer_mp3)"></i>
          </p>
        </div>

         <!-- 句子中文翻译-->
        <div class="p-container phonictext">
          <div id="headerdiv">
            <div class="headertitle">{{ lang.sentence_guess }}</div>
          </div>
          <p>{{ lang.phonictext_desc }}</p>
          <p class="p-english family-english size-english orange-bold">
            <span class="p-order">{{ lang.ask }}:</span>
            <span v-text="Data.sentence_cn"></span>
          </p>
          <p class="p-chinese family-chinese size-chinese blue-bold" v-if="Data.sentence_en_answer != null">
            <span class="p-order">{{ lang.answer }}:</span>
            <span v-text="Data.sentence_cn_answer"></span>
          </p>
        </div>

        <!-- 句子中文翻译-->
        <div class="p-container phonictext" v-if="Data.words.length > 0">
          <div id="headerdiv">
            <div class="headertitle">{{ lang.check }}</div>
          </div>
          <div id="key_word" class="flex-row-left">{{ lang.key_word }}</div></br>
          <div class="resource-list" id="key_word">
            <span v-for="word in Data.words">
              <a :href="'/resource/word_v2/' + word.id + tailUrl"><b>  {{word.word_name}}  </b><i v-if="Data.words.length>1" class="cut-line">  </i></a>
            </span>
          </div>
        </div>

      </div>

</div>
</template>

<script>
require('@/assets/css/resource.css')
import 'font-awesome/css/font-awesome.css'

import BaseVue from '@/components/BaseVue'

export default {
  name: 'SentenceTemplate',
  extends: BaseVue,
  data () {
    return {
      Data: {
        id: 123,
        sentence_en: '',
        sentence_cn: '',
        sentence_en_mp3: '',
        sentence_en_answer: '',
        sentence_cn_answer: '',
        sentence_en_answer_mp3: '',
        cover_picture_link: '',
        words: [{
          id: "8ABA58D1691561B14B2BF7C156307963",
          word_name: "center"
        }],
        url_params: ''
      }
    }
  },
  computed: {
    tailUrl: function() {
      return this.url_params === '' ? '' : '?' + this.url_params
    }
  },
  created: async function(){
    await this.getLang()
    document.title = this.lang.SentenceTemplateTitle
    let data_id = this.$route.params.id
    let url = this.GATEWAY_ORIGINAL + 'bigdata/unit_knowledge/query_sentence?id=' + data_id
    let that = this;
    this.queryData(url, function (data) {
      that.Data = data
    })
  },
  methods: {
    sound: function(url){
      var audio= new Audio(url);
      audio.play() //autoplay自动播放 loop循环播放  pause暂停
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/resource/Sentence.vue